export default __webpack_public_path__ + "static/proxicash-3c3a233deb57b43c3cf15df3797258b4.png";